import React from 'react';
import {Link} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiPhone,FiMapPin,FiMail,FiClock}=FiIcons;

const Footer=()=> {
return (
 <footer className="bg-gray-900 text-white">
 <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
 <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
 {/* Company Info */}
 <div className="col-span-1 md:col-span-2">
 <div className="flex items-center space-x-2 mb-4">
 <div className="w-10 h-10 bg-red-500 rounded-full flex items-center justify-center">
 <span className="text-white font-bold text-xl">T</span>
 </div>
 <span className="text-xl font-bold">Tung Hing Bakery</span>
 </div>
 <p className="text-gray-300 mb-4 max-w-md"> Fresh baked goods and traditional Chinese pastries made daily with the finest ingredients. Serving the Toronto community with authentic flavors and quality since our establishment. </p>
 </div>
 {/* Quick Links */}
 <div>
 <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
 <ul className="space-y-2">
 <li><Link to="/" className="text-gray-300 hover:text-red-400 transition-colors">Home</Link></li>
 <li><Link to="/services" className="text-gray-300 hover:text-red-400 transition-colors">Services</Link></li>
 <li><Link to="/menu-gallery" className="text-gray-300 hover:text-red-400 transition-colors">Menu Gallery</Link></li>
 <li><Link to="/about" className="text-gray-300 hover:text-red-400 transition-colors">About Us</Link></li>
 <li><Link to="/contact" className="text-gray-300 hover:text-red-400 transition-colors">Contact Us</Link></li>
 </ul>
 </div>
 {/* Contact Info */}
 <div>
 <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
 <div className="space-y-3">
 <div className="flex items-center space-x-2">
 <SafeIcon icon={FiPhone} className="w-4 h-4 text-red-400" />
 <span className="text-gray-300">+14164659103</span>
 </div>
 <div className="flex items-start space-x-2">
 <SafeIcon icon={FiMapPin} className="w-4 h-4 text-red-400 mt-1" />
 <span className="text-gray-300">353 Broadview Ave,Toronto,ON M4M 2H1,Canada</span>
 </div>
 <div className="flex items-center space-x-2">
 <SafeIcon icon={FiClock} className="w-4 h-4 text-red-400" />
 <span className="text-gray-300">Daily: 7:00 AM - 8:00 PM</span>
 </div>
 </div>
 </div>
 </div>
 {/* Bottom Bar */}
 <div className="border-t border-gray-700 mt-8 pt-8 text-center">
 <p className="text-gray-400"> © 2025 Tung Hing Bakery. All rights reserved. </p>
 </div>
 </div>
 </footer>
 );
};

export default Footer;